import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingPageHeaderComponent } from './landing-page-header/landing-page-header.component';
import { SubRoutesPageHeaderComponent } from './sub-routes-page-header/sub-routes-page-header.component';
import { IonicModule } from '@ionic/angular';
import { UiModule } from '@monorepo/ui';
import { TicketGenerationSuccessComponent } from './ticket-generation-success/ticket-generation-success.component';
import { AdditionalInfoGridComponent } from './additional-info-grid/additional-info-grid.component';
import { BriefDetailsCardComponent } from './brief-details-card/brief-details-card.component';
import { ZfTabsComponent } from './zf-tabs/zf-tabs.component';
import { FormsModule } from '@angular/forms';
import { FabricGrnLotListingComponent } from './fabric-grn-lot-listing/fabric-grn-lot-listing.component';
import { TrimsGrnLotListingComponent } from './trims-grn-lot-listing/trims-grn-lot-listing.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslationLoaderService } from '@monorepo/services';
import { HttpClient } from '@angular/common/http';
import { SelectItemsListingTableComponent } from './select-items-listing-table/select-items-listing-table.component';
import { GrnLotListingComponent } from './grn-lot-listing/grn-lot-listing.component';
import { UserOptionsPopoverComponent } from './user-options-popover/user-options-popover.component';
import { SearchTagModalComponent } from './search-tag-modal/search-tag-modal.component';
import { DefaultZeroDirective } from './select-items-listing-table/default-zero.directive';

@NgModule({
  declarations: [
    LandingPageHeaderComponent,
    SubRoutesPageHeaderComponent,
    TicketGenerationSuccessComponent,
    AdditionalInfoGridComponent,
    BriefDetailsCardComponent,
    ZfTabsComponent,
    FabricGrnLotListingComponent,
    TrimsGrnLotListingComponent,
    SelectItemsListingTableComponent,
    GrnLotListingComponent,
    UserOptionsPopoverComponent,
    SearchTagModalComponent,
    DefaultZeroDirective,
  ],
  imports: [
    CommonModule,
    IonicModule,
    UiModule,
    FormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslationLoaderService(http, 'organizi8'),
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    LandingPageHeaderComponent,
    SubRoutesPageHeaderComponent,
    TicketGenerationSuccessComponent,
    BriefDetailsCardComponent,
    ZfTabsComponent,
    FabricGrnLotListingComponent,
    TrimsGrnLotListingComponent,
    SelectItemsListingTableComponent,
    GrnLotListingComponent,
    SearchTagModalComponent,
  ],
})
export class CommonComponentsModule {}
